import { render, staticRenderFns } from "./quickLogin.vue?vue&type=template&id=b984750a&scoped=true"
import script from "./quickLogin.vue?vue&type=script&lang=js"
export * from "./quickLogin.vue?vue&type=script&lang=js"
import style0 from "./quickLogin.vue?vue&type=style&index=0&id=b984750a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b984750a",
  null
  
)

export default component.exports